import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver-es';

@Injectable()
export class FileUtils {

  constructor() {
  }

  downloadFile(content: any, mimeType: string, fileName: string) {
    const blob = new Blob([content], { type: mimeType });
    saveAs(blob, fileName);
  }

  downloadFileFromDB(content: any, mimeType: string, fileName: string) {
    const blob = new Blob([this.base64ToArrayBuffer(content)], { type: mimeType });
    saveAs(blob, fileName);
  }

  convertToBlobPart(content: any): BlobPart[] {
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return [new Uint8Array(byteNumbers)];
  }

  base64ToArrayBuffer(data) {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

}